import * as Long from "long";
var UtilNumber = /** @class */ (function () {
    function UtilNumber() {
        var _this = this;
        this.numberFormat = new Intl.NumberFormat(undefined, {
            maximumFractionDigits: 0,
            useGrouping: true,
        });
        this.clamp = function (value, min, max) { return Math.max(min, Math.min(max, value)); };
        this.pad = function (num, size) {
            var str = num.toString();
            while (str.length < size) {
                str = "0" + str;
            }
            return str;
        };
        this.lerp = function (src, dest, delta) { return src + delta * (dest - src); };
        this.multiplyWithRemainder = function (a, b, fractionDigits) {
            var aHasFractions = _this.hasFraction(a);
            var bHasFractions = _this.hasFraction(b);
            if (!aHasFractions && !bHasFractions) {
                return [Long.fromValue(a).multiply(Long.fromValue(b)), Long.ZERO];
            }
            fractionDigits = fractionDigits || _this.getMaxFractionDigits(a, b);
            var extraDigitCount = aHasFractions && bHasFractions ? fractionDigits * 2 : fractionDigits;
            var multiplierA = aHasFractions ? Math.pow(10, fractionDigits) : 1;
            var multiplierB = bHasFractions ? Math.pow(10, fractionDigits) : 1;
            var longA = a instanceof Long ? a : Long.fromValue(a * multiplierA);
            var longB = b instanceof Long ? b : Long.fromValue(b * multiplierB);
            var product = longA.multiply(longB);
            var productStr = product.toString();
            var fractional = Long.fromValue(productStr.slice(productStr.length - extraDigitCount));
            return [product.divide(Math.pow(10, extraDigitCount)), fractional];
        };
        this.multiplyRounding = function (base, multiplier) {
            var buffAmount = utilNumber.multiplyWithRemainder(base, multiplier);
            return utilNumber.roundLong(buffAmount[0], buffAmount[1]);
        };
        this.roundLong = function (base, reminder) {
            var strReminder = reminder.toString();
            var firsChar = Long.fromValue(strReminder.charAt(0));
            if (firsChar.greaterThanOrEqual(5)) {
                return base.add(Long.ONE);
            }
            return base;
        };
        this.hasFraction = function (value) { return value.toString().indexOf(".") >= 0; };
        this.format = function (value) {
            return _this.numberFormat.format(value.toString());
        };
        this.getMaxFractionDigits = function (a, b) {
            var arrA = a.toString().split(".");
            var arrB = b.toString().split(".");
            var digitsA = arrA[1] ? arrA[1].length : 0;
            var digitsB = arrB[1] ? arrB[1].length : 0;
            return Math.max(digitsA, digitsB, 2);
        };
        this.limitLow = function (value, lowLimit) {
            if (lowLimit === void 0) { lowLimit = 0; }
            return Math.max(value, lowLimit);
        };
        this.limitHigh = function (value, highLimit) {
            if (highLimit === void 0) { highLimit = 0; }
            return Math.min(value, highLimit);
        };
        this.roundToPrecision = function (value, precision) {
            return parseFloat(value.toFixed(precision));
        };
        /**
         * Converts "cent" values to "euros".
         * Please don't refactor this to use toFixed method, because rounding issues may arise.
         * @param {number} value Value in cents.
         * @returns {number} Value in Euros.
         */
        this.convertFromCents = function (value) {
            var result = value / 100;
            var dotIndex = result.toString().indexOf(".");
            if (dotIndex > -1) {
                return parseFloat(result.toString().substring(0, dotIndex + 3));
            }
            return result;
        };
        this.formatCurrency = function (value, currencyCode) {
            var formatter = Intl.NumberFormat(undefined, {
                currency: currencyCode,
                currencyDisplay: "symbol",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                minimumIntegerDigits: 1,
                style: "currency",
                useGrouping: true,
            });
            return formatter.format(_this.convertFromCents(value));
        };
        this.sortNumbersAscending = function (a, b) { return a - b; };
        this.sortNumbersDescending = function (a, b) { return b - a; };
        this.distinct = function (value, index, self) {
            return self.indexOf(value) === index;
        };
    }
    return UtilNumber;
}());
export var utilNumber = new UtilNumber();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilNumber.ts
// module id = 19
// module chunks = 3